export enum LovesConcept {
  ExpressCheckout = 'express-checkout',
  Subway = 'subway',
}
